import { render, staticRenderFns } from "./MainShareIcon.vue?vue&type=template&id=2dc01621&scoped=true&"
import script from "./MainShareIcon.vue?vue&type=script&lang=js&"
export * from "./MainShareIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2dc01621",
  null
  ,true
)

export default component.exports